import { API } from '..';
import { IListCreatorModel } from '../../models';
import { VerificationRequest } from '../../models/verification-request.model';
import {
  EligibilityKind,
  EligibilityResult,
  unwrapEligibility,
} from '../user/eligibility.api';
import { rejectReasonParams } from './req-donate.api';

interface BankAccountRequest {
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;
}

interface BankAccountResponse {
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;
}

export const fetchUsersApi = (
  page = 1,
  pageSize = 10,
  filters = {},
  sortField = '',
  isSortDescending = true
) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/user-service/admin/profile/search', {
      // email: 'string',
      // fullName: 'm',
      // dateFrom: '2024-11-01T16:28:25.056Z',
      // dateTo: '2024-11-01T16:28:25.056Z',
      // status: 0,
      ...filters,
      pageNumber: page,
      pageSize,
      sortField,
      isSortDescending,
    })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const blockUser = (userId, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/admin/profile/block/${userId}`, null, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const blockCommentUser = (userId, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/reportcomments/block/${userId}`, null, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const unBlockCommentUser = (userId, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/reportcomments/unlock/${userId}`, null, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
/** Duyệt tích xanh creator. `note` là lý do duyệt ngoại lệ khi người dùng chưa đạt điều kiện xét duyệt. */
export const confirmCreator = (userId, totpCode?: string, note?: string) => {
  const params: Record<string, string | undefined> = { totpCode };
  if (note && note.trim()) params.note = note.trim();
  return new Promise<any>((resolve, reject) => {
    API.post(`/v1/user-service/admin/profile/confirm-creator/${userId}`, null, { params })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

/** Từ chối yêu cầu tích xanh creator kèm mã lý do và phần ghi thêm. */
export const rejectCreatorAPI = (userId: string, reasonCode: string, reasonText?: string) =>
  API.post(`/v1/user-service/admin/profile/reject-creator/${userId}`, null, {
    params: rejectReasonParams(reasonCode, reasonText),
  });

/** Danh sách điều kiện của một tài khoản, kiểm theo góc nhìn admin (mục số điện thoại luôn là chưa kiểm được). */
export const getAdminEligibility = async (
  userId: string,
  kind: EligibilityKind
): Promise<EligibilityResult> => {
  const res = await API.get(`/v1/user-service/admin/profile/eligibility/${userId}`, {
    params: { kind },
  });
  return unwrapEligibility(res.data);
};
export const deleteUser = (userId, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.delete(`/v1/user-service/admin/profile/${userId}`, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const toggleChangeReciveDonateAPI = async (id: string, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/admin/profile/togglechangerecivedonate/${id}`, null, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const updateBankAccount = async (data: BankAccountRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/payment-service/users/bank-account`, data)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const getBankAccount = async (): Promise<BankAccountResponse> => {
  const response = await API.get('/v1/payment-service/users/bank-account');
  return response.data;
};

export const submitVerificationRequest = (request: VerificationRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/user-service/users/new-request-creator', request)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const getCreatorRequest = (userId: string) => {
  return new Promise<VerificationRequest>((resolve, reject) => {
    API.get(`/v1/user-service/users/get-creator-request/${userId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
